import useReveal from "@/lib/useReveal";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Intro from "@/components/site/Intro";
import Situations from "@/components/site/Situations";
import Missions from "@/components/site/Missions";
import Method from "@/components/site/Method";
import Interventions from "@/components/site/Interventions";
import Credibility from "@/components/site/Credibility";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  useReveal();
  return (
    <main data-testid="home-page" className="bg-[#FAF8F5] text-[#171D2A]">
      <Header />
      <Hero />
      <Intro />
      <Situations />
      <Missions />
      <Interventions />
      <Method />
      <Credibility />
      <Contact />
      <Footer />
    </main>
  );
}
